import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import {
  IonAvatar,
  IonButton,
  IonContent,
  IonFooter,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRouterLink,
  IonSkeletonText,
  IonSplitPane,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonText,
} from '@ionic/angular/standalone';
import { AuthStateStore } from '@libs/core/lib/auth/auth-state.store';

import { AppAlerts } from '@libs/core/lib/utils/app-alerts';
import { ThemeToggleComponent } from '@libs/core/lib/utils/theme/theme-toggle.component';
import { ThemeStore } from '@libs/core/lib/utils/theme/theme.store';
import { LanguageSwitcherComponent } from '@libs/mtjr/shared/i18n/language-switcher.component';
import { UserStore } from '@libs/mtjr/shared/user/user.store';
import { WalletStore } from '@libs/mtjr/shared/wallet/wallet.store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mav-tabs',
  imports: [
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonLabel,
    RouterLink,
    IonMenu,
    IonContent,
    IonSplitPane,
    IonList,
    RouterLink,
    IonRouterLink,
    IonItem,
    RouterLinkActive,
    IonLabel,
    IonAvatar,
    IonText,
    IonFooter,
    ThemeToggleComponent,
    IonSkeletonText,
    IonButton,
    TranslatePipe,
    LanguageSwitcherComponent,
    IonMenuToggle,
  ],
  templateUrl: './tabs.page.html',
})
export class TabsPage {
  authStore = inject(AuthStateStore);
  userStore = inject(UserStore);
  alerts = inject(AppAlerts);
  themeStore = inject(ThemeStore);
  router = inject(Router);
  walletStore = inject(WalletStore);

  async signIn() {
    this.authStore.signIn();
  }

  async signOut() {
    const confirm = await this.alerts.yesNoAlertTR({
      header: 'USER.SIGN_OUT',
      message: 'USER.CONFIRM_SIGN_OUT',
    });
    if (confirm) {
      this.authStore.signOut();
    }
  }
}
